import React from 'react';
import { Box, Grid, Typography, TextField, Stack } from '@mui/material';

export default function MainUserInfo({ formData, formErrors, handleInputChange, showPassField }) {

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
                        Hauptbenutzerinformationen:
                    </Typography>
                    <Stack spacing={1}>
                        <TextField
                            label="Vorname"
                            variant="standard"
                            name="firstName"
                            value={formData.firstName || ''}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            error={!!formErrors.firstName}
                            helperText={formErrors.firstName}
                        />

                        <TextField
                            label="Nachname"
                            variant="standard"
                            name="lastName"
                            value={formData.lastName || ''}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            error={!!formErrors.lastName}
                            helperText={formErrors.lastName}
                        />

                        <TextField
                            label="Email"
                            variant="standard"
                            type="email"
                            name="email"
                            value={formData.email || ''}
                            onChange={handleInputChange}
                            fullWidth
                            required
                            error={!!formErrors.email}
                            helperText={formErrors.email}
                        />

                        <TextField
                            label="Telefon"
                            variant="standard"
                            name="phoneNumber"
                            value={formData.phoneNumber || ''}
                            onChange={handleInputChange}
                            fullWidth
                            error={!!formErrors.phoneNumber}
                            helperText={formErrors.phoneNumber}
                        />

                        <TextField
                            label="Sozialversicherungsnummer"
                            variant="standard"
                            name="socialNumber"
                            value={formData.socialNumber || ''}
                            onChange={handleInputChange}
                            fullWidth
                            error={!!formErrors.socialNumber}
                            helperText={formErrors.socialNumber}
                        />

                        <TextField
                            label="Stadt"
                            variant="standard"
                            name="city"
                            value={formData.city || ''}
                            onChange={handleInputChange}
                            fullWidth
                            error={!!formErrors.city}
                            helperText={formErrors.city}
                        />

                        <TextField
                            label="Straße"
                            variant="standard"
                            name="street"
                            value={formData.street || ''}
                            onChange={handleInputChange}
                            fullWidth
                            error={!!formErrors.street}
                            helperText={formErrors.street}
                        />

                        <TextField
                            label="Hausnummer"
                            variant="standard"
                            name="houseNumber"
                            value={formData.houseNumber || ''}
                            onChange={handleInputChange}
                            fullWidth
                            error={!!formErrors.houseNumber}
                            helperText={formErrors.houseNumber}
                        />
                        {showPassField && <TextField
                            label="Passwort"
                            variant="standard"
                            type='password'
                            name="password"
                            value={formData.password || ''}
                            onChange={handleInputChange}
                            fullWidth
                            error={!!formErrors.password}
                            helperText={formErrors.password}
                        />}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}
